import React from 'react';
import PropTypes from 'prop-types';
import * as S from './ToggleBtn.styled';

const ToggleBtn = ({
  isChecked = false,
  onChange,
  id,
  lableOn = 'Enable',
  labelOff = 'Disabled',
  isReverse,
  style,
  textStyle,
}) => {
  return (
    <S.Container isReverse={isReverse} style={style}>
      <S.Input type='checkbox' id={id} checked={isChecked} onChange={() => {}} />
      <S.Button htmlFor={id} onClick={() => onChange(!isChecked)} />
      <S.Lable htmlFor={id} style={textStyle}>
        {!isChecked ? labelOff : lableOn}
      </S.Lable>
    </S.Container>
  );
};

ToggleBtn.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};

export default ToggleBtn;
